module.exports = __webpack_public_path__ + "img/medal-exam.0c3b264c.svg";